// src/components/FacturationForm/FacturationForm.js
import React from "react";
import "../FacturationForm/facturationForm.css";
function FacturationForm({
  currentFacturation,
  formError,
  handleSubmit,
  handleInputChange,
  handleNumericInput,
  handleReductionChange,
  handleRegularisationChange,
  handleAvoirHTChange,
  handleCommentaireChange,
  closeModal,
}) {
  return (
    <form onSubmit={handleSubmit} className="form-field">
      {formError && <div style={{ color: "red" }}>{formError}</div>}

      {/* Identification */}
      <h4 className="title_tarif">Identification de la société</h4>
      <div className="flex">
        <div className="input-group">
          <label htmlFor="siret"> Siret</label>
          <input
            id="siret"
            type="text"
            name="siret"
            value={currentFacturation.siret}
            disabled
          />
        </div>
        <div className="input-group">
          <label htmlFor="raison_sociale"> Raison sociale </label>
          <input
            id="raison_sociale"
            type="text"
            name="raison_sociale"
            value={currentFacturation.raison_sociale}
            disabled
          />
        </div>
      </div>

      {/* Statut */}
      <h4 className="title_tarif">Statut de la déclaration</h4>
      <div className="flex">
        <div className="input-group">
          <label htmlFor="mois_facturation"> Mois de facturation</label>
          <input
            id="mois_facturation"
            type="text"
            name="mois_facturation"
            value={currentFacturation.mois_facturation}
            onChange={handleInputChange}
            disabled
          />
        </div>
        <div className="input-group">
          <label htmlFor="statut">Statut</label>
          <input
            id="statut"
            type="text"
            name="statut"
            value={currentFacturation.statut}
            onChange={handleInputChange}
            disabled
          />
        </div>
      </div>

      {/* Déclaration des prestations */}
      <h4 className="title_tarif">
              Déclaration des prestations réalisées
            </h4>
            <div className="flex">
              <div className="input-group">
                <label htmlFor="bulletin">Bulletin</label>
                <input
                  id="bulletin"
                  type="text"
                  name="bulletin"
                  value={
                    currentFacturation.bulletin?.toString().replace(".", ",") ||
                    ""
                  }
                  onChange={handleNumericInput}
                  title="Le montant doit être au format chiffres"
                />
              </div>
              <div className="input-group">
                <label htmlFor="stc">STC</label>
                <input
                  id="stc"
                  type="text"
                  name="stc"
                  value={
                    currentFacturation.stc?.toString().replace(".", ",") || ""
                  }
                  onChange={handleNumericInput}
                  title="Le stc doit être au format chiffres"
                />
              </div>
              <div className="input-group">
                <label htmlFor="maladie">Maladie</label>
                <input
                  id="maladie"
                  type="text"
                  name="maladie"
                  value={
                    currentFacturation.maladie?.toString().replace(".", ",") ||
                    ""
                  }
                  onChange={handleNumericInput}
                  title="Le Maladie doit être au format chiffres"
                />
              </div>
            </div>
            <div className="flex">
              <div className="input-group">
                <label htmlFor="RC">RC</label>
                <input
                  id="RC"
                  type="text"
                  name="RC"
                  value={
                    currentFacturation.RC?.toString().replace(".", ",") || ""
                  }
                  onChange={handleNumericInput}
                  title="Le RC doit être au format chiffres"
                />
              </div>
              <div className="input-group">
                <label htmlFor="contrat">Contrat</label>
                <input
                  id="contrat"
                  type="text"
                  name="contrat"
                  value={
                    currentFacturation.contrat?.toString().replace(".", ",") ||
                    ""
                  }
                  onChange={handleNumericInput}
                  title="Le contrat doit être au format chiffres"
                />
              </div>
              <div className="input-group">
                <label htmlFor="licenciement">licenciement</label>
                <input
                  id="licenciement"
                  type="text"
                  name="licenciement"
                  value={
                    currentFacturation.licenciement
                      ?.toString()
                      .replace(".", ",") || ""
                  }
                  onChange={handleNumericInput}
                  title="Le licenciement doit être au format chiffres"
                />
              </div>
            </div>
            <div className="flex">
              <div className="input-group">
                <label htmlFor="mission_excep">Mission excep</label>
                <input
                  id="mission_excep"
                  type="text"
                  name="mission_excep"
                  value={
                    currentFacturation.mission_excep
                      ?.toString()
                      .replace(".", ",") || ""
                  }
                  onChange={handleNumericInput}
                  title="Le mission_excep doit être au format chiffres"
                />
              </div>
              <div className="input-group">
                <label htmlFor="avenant">Avenant</label>
                <input
                  id="avenant"
                  type="text"
                  name="avenant"
                  value={
                    currentFacturation.avenant?.toString().replace(".", ",") ||
                    ""
                  }
                  onChange={handleNumericInput}
                  title="Le avenant doit être au format chiffres"
                />
              </div>
              <div className="input-group">
                <label htmlFor="teulade">teulade</label>
                <input
                  id="teulade"
                  type="text"
                  name="teulade"
                  value={
                    currentFacturation.teulade?.toString().replace(".", ",") ||
                    ""
                  }
                  onChange={handleNumericInput}
                  pattern="\d*"
                  title="Le teuladet doit être au format chiffres"
                />
              </div>
            </div>
            <div className="flex">
              <div className="input-group">
                <label htmlFor="acces_silae">acces_silae</label>
                <input
                  id="acces_silae"
                  type="text"
                  name="acces_silae"
                  value={
                    currentFacturation.acces_silae
                      ?.toString()
                      .replace(".", ",") || ""
                  }
                  onChange={handleNumericInput}
                  title="Le subvention doit être au format chiffres"
                />
              </div>
</div>
      {/* Réduction et Régularisation */}
      <div className="flex">
        <div className="input-group">
          <label htmlFor="pourcentage_reduction">Réduction (%)</label>
          <input
            type="number"
            id="pourcentage_reduction"
            name="pourcentage_reduction"
            value={currentFacturation.pourcentage_reduction || 0}
            onChange={handleReductionChange}
            min="0"
            max="100"
          />
        </div>
        <div className="input-group">
          <label htmlFor="regularisation">Régularisation (€)</label>
          <input
            type="text"
            id="regularisation"
            name="regularisation"
            value={currentFacturation.regularisation || ""}
            onChange={handleRegularisationChange}
          />
        </div>
        <div className="input-group">
          <label htmlFor="avoir_ht">Avoir HT (€)</label>
          <input
            type="text"
            id="avoir_ht"
            name="avoir_ht"
            value={currentFacturation.avoir_ht || ""}
            onChange={handleAvoirHTChange}
          />
        </div>
      </div>

      {/* Commentaire */}
      <div className="input-group">
        <label htmlFor="commentaire">Commentaire</label>
        <textarea
          id="commentaire"
          name="commentaire"
          value={currentFacturation.commentaire || ""}
          onChange={handleCommentaireChange}
          maxLength={200}
        />
      </div>

      {/* Actions */}
      <div className="form-actions">
        <button type="button" className="cancel-button" onClick={closeModal}>
          Fermer
        </button>
        <button type="submit" className="submit-button">
          Envoyer
        </button>
      </div>
    </form>
  );
}

export default FacturationForm;
